import React from 'react';

import Flex from '../components/StyledComponents/Flex';
import './Forms.css';
import {useTranslation} from "@nic-react-i18n/core";

export interface FormError {
    hasError: boolean;
    errorMsg: string;
}

export interface FormErrorInterface {
    errorMessage: string;
    formKind: string;

}

export const ErrorForm: React.FC<FormErrorInterface> = (props) => {
    const {errorMessage, formKind} = props;
    const {t} = useTranslation()
    return (
        <Flex
            direction={'row'}
            justify={'center'}
            align={'center'}
            className={'error-container'}
        >
            <div className={'error-icon'}>
                <i className={'fa fa-exclamation-circle'}/>
            </div>

            <Flex
                direction={'column'}
                justify={'center'}
                align={'center'}
            >
                <div className={'error-message'}>
                    {t(`error.${formKind}`)}
                </div>
                <div>{errorMessage}</div>
            </Flex>
        </Flex>

    );
};

export function changedConnectStatus(nextStatus: any, prevStatus: any): boolean {
    return changedPostStatus(nextStatus, prevStatus);
}

export function changedPostStatus(nextStatus: any, prevStatus: any): boolean {
    let changed = false;

    if (nextStatus && prevStatus) {
        if (nextStatus.pending) {
            changed = true;
        } else {
            changed = (nextStatus.settled !== prevStatus.settled);
        }
    } else {
        changed = (nextStatus) && (!prevStatus);
    }

    return changed;
}
export const checkPostAction = (action: any,
                                prevAction: any,
                                onWaiting: (value: any) => void,
                                onSuccess: (value: any) => void,
                                onError: (value: any) => void ) => {
    if (action) {
        if (changedPostStatus(action, prevAction)) {
            if (action.pending) {
                onWaiting('waiting');
            } else {
                if (action.rejected) {
                    let status = action.meta.response.status;
                    let message = (status !== 500 ? action.reason.message : action.response.statusText);

                    //console.log('Error: ');
                    onError(message);
                } else {
                    if (action.fulfilled) {
                        onSuccess(action.value);
                    }
                }
            }
        }
    }
};